module.exports = __webpack_public_path__ + "715fe53c78aded0659604cbd8be9236c.svg";